import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ConfigService} from './config.service';
import {ManageOrganisationService} from './manage-organisation.service';
import {TransactionRentMatchRule} from '../models/finance/transaction-rent-match-rule';
import {TransactionRentMatchRulePostPatch} from '../models/finance/transaction-rent-match-rule-post-patch';
import {CreateMatchRulePostModel} from '../models/finance/transactions/create-match-rule-post-model';
import {TransactionRentMatchRulesTableSortColumn} from '../models/finance/transaction-rent-match-rule/transaction-rent-match-rules-table-sort-column';
import {SortOrder} from '../models/sort-order';
import {TransactionRentMatchRuleList} from '../models/finance/transaction-rent-match-rule/transaction-rent-match-rule-list';

@Injectable()
export class TransactionRentMatchRulesService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService,
        private manageOrganisationService: ManageOrganisationService) {
    }

    getRentMatchRules(
        organisationReference: string,
        propertyReferences: string[],
        tenancyGuid: string,
        showArchivedOnly: boolean,
        searchTerm: string,
        pageSize: number,
        page: number,
        sortColumn: TransactionRentMatchRulesTableSortColumn,
        sortOrder: SortOrder,
    ){
        let params = new HttpParams()
            .set('showArchivedOnly', showArchivedOnly)
            .set('pageSize', pageSize)
            .set('page', page)
            .set('sortColumn', sortColumn)
            .set('sortOrder', sortOrder)

        if(propertyReferences != null){
            propertyReferences.forEach(m => params = params.append('propertyReferences', m));
        }
        if (tenancyGuid != null) {
            params = params.set('tenancyGuid', tenancyGuid);
        }
        if (searchTerm != null) {
            params = params.set('searchTerm', searchTerm);
        }
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/rent-match-rules`;
        return this.http.get<TransactionRentMatchRuleList>(url, {params});
    }

    updateRentMatchRule(organisationReference: string, ruleGuid: string, model: TransactionRentMatchRulePostPatch) {
        return this.http.patch<TransactionRentMatchRule>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/rent-match-rules/${ruleGuid}`, model)
    }

    deleteRentMatchRule(organisationReference: string, ruleGuid: string) {
        return this.http.delete<void>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/rent-match-rules/${ruleGuid}`)
    }

    getMatchRule(ruleGuid: string){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/rent-match-rules/${ruleGuid}`;
        return this.http.get<TransactionRentMatchRule>(url);
    }

    createRule(model: CreateMatchRulePostModel){
        const organisationReference = this.manageOrganisationService.getOrganisationReference();
        const url = `${this.configService.baseUrl}/manage/organisation/${organisationReference}/rent-match-rules`;
        return this.http.post<{ guid: string }>(url, model);
    }
}
